/**
 *
 */
export interface IProcessPlaceholderFactoryCfg {
  getField?: ReplacePlaceholdersGetField;
  left: string;
  needToTrim?: boolean;
  pathParts: PathParts;
  postProcess?: ReplacePlaceholdersPostProcess;
  processSlice?: ReplacePlaceholdersProcessSlice;
  right: string;
}

/**
 *
 */
export interface IReplacePlaceholdersCfg {
  getField?: ReplacePlaceholdersGetField;
  left?: string;
  right?: string;
  isLazy?: boolean;
  needToTrim?: boolean;
  postProcess?: ReplacePlaceholdersPostProcess;
  processSlice?: ReplacePlaceholdersProcessSlice;
  processPlaceholder?: ProcessPlaceholder;
}

/**
 *
 */
export type PathParts = Record<string, string>;

/**
 *
 */
export type ProcessPlaceholder = (p: string) => string;

/**
 *
 */
export type ProcessPlaceholderFactory = (
  cfg: IProcessPlaceholderFactoryCfg
) => ProcessPlaceholder;

/**
 *
 */
export type ReplacePlaceholdersGetField = (o: PathParts, f: string) => string;

/**
 *
 */
export type ReplacePlaceholdersPostProcess = (
  s: string,
  sl: string,
  slP: string
) => string;

/**
 *
 */
export type ReplacePlaceholders = (
  str: string,
  pathParts: PathParts,
  cfg?: IReplacePlaceholdersCfg
) => string;

/**
 *
 */
export type ReplacePlaceholdersProcessSlice = (s: string) => string;

/**
 *
 */
const processPlaceholderFactory: ProcessPlaceholderFactory = ({
  getField = (o, f) => o[f],
  left,
  needToTrim = true,
  pathParts,
  postProcess = s => s,
  processSlice = s => s,
  right,
}) => {
  return p => {
    let slice = p.slice(left.length, -right.length);
    if (needToTrim) slice = slice.trim();

    const sliceProcessed = processSlice(slice);
    return postProcess(
      getField(pathParts, sliceProcessed) ?? p,
      slice,
      sliceProcessed
    );
  };
};

/**
 *
 * processPlaceholder:
 *   placeholder
 *     => slice (isLazy) => sliceTrimed [needToTrim]
 *     => processSlice => postProcess (getField)
 */
const fn: ReplacePlaceholders = (str, pathParts, cfg = {}) => {
  const { left = '{', right = '}', isLazy = true, processPlaceholder } = cfg;

  const processor =
    processPlaceholder ??
    processPlaceholderFactory({ ...cfg, left, pathParts, right });

  return str.replace(
    new RegExp(left + '.+' + (isLazy ? '?' : '') + right, 'g'),
    processor
  );
};

export default fn;
